import { useEffect, useState } from "react";

// The V2 designs (Brand Mode, Athlete Mode) are drawn on a 1440px frame.
// Instead of stretching that layout across wide windows with fixed 13px
// type, the shells zoom the whole frame to the window width, so the page
// always looks like the Figma frame at "fit to width": on a 1710px-wide
// window everything renders at ~1.19x, on 1920 at 1.33x. Below 1440 the
// responsive layout takes over at 1x.
export const DESIGN_WIDTH = 1440;
export const MAX_SCALE = 2.5;

const read = () => {
  if (typeof window === "undefined") return { scale: 1, height: 0 };
  const width = window.innerWidth;
  const scale = width <= DESIGN_WIDTH ? 1 : Math.min(MAX_SCALE, Math.round((width / DESIGN_WIDTH) * 1000) / 1000);
  return { scale, height: window.innerHeight };
};

export const useFitScale = () => {
  const [state, setState] = useState(read);
  useEffect(() => {
    const onResize = () => setState(read());
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);
  return state;
};

// Inline style for a shell root: CSS zoom plus a min-height that still
// equals the real viewport once zoomed.
export const fitScaleStyle = ({ scale, height }) => ({
  zoom: scale,
  minHeight: height ? `${Math.round(height / scale)}px` : undefined,
});
